import React from 'react';

const DataSharing = () => {
  return (
    <div className="prose prose-gray max-w-none">
      <p className="text-gray-600 leading-relaxed">
        We share your data only in specific circumstances:
      </p>
      <ul className="list-disc pl-6 mt-4 space-y-2 text-gray-600">
        <li>With your explicit consent</li>
        <li>With service providers who assist in our operations</li>
        <li>When required by law or to protect rights</li>
        <li>In HIPAA-compliant anonymized form for analytics purposes</li>
      </ul>
    </div>
  );
};

export default DataSharing;